import * as React from 'react';
import { useSelector } from 'react-redux';

import { usePuids } from '../../../hooks';
import { selectRegionId } from '../../../selectors/filters';
import { TAdBannerCommonParameters } from '../types';
import { generateRandomString } from '../utils';

/**
 * Общие, региональные параметры баннера: готовые puids, regionId и стабильный `placeId`.
 *
 * `placeId` генерируется один раз на смонтированный баннер и должен быть уникален между
 * независимыми React-корнями на странице, поэтому используется случайная hex-строка,
 * а не React `useId()`. Значение DOM/CSS-безопасно — ad-banner-frontend строит из него id
 * Adfox-контейнера.
 */
export function useAdBannerCommonParameters(): TAdBannerCommonParameters {
  const puids = usePuids();
  // Регион всегда проставляется при инициализации стора; 0 — страховка на случай пустых фильтров
  const regionId = useSelector(selectRegionId) ?? 0;
  const placeId = React.useMemo(() => generateRandomString(), []);

  return React.useMemo(() => ({ puids, regionId, placeId }), [puids, regionId, placeId]);
}
